
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0.25 15 20.66","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.165 1C5.707 1 4.523 2.16 4.523 3.591v6.91c0 1.43 1.184 2.59 2.642 2.59 1.459 0 2.642-1.16 2.642-2.59V3.59C9.807 2.161 8.624 1 7.165 1z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.327 8.773v1.728c0 3.338-2.76 6.045-6.164 6.045S1 13.839 1 10.501V8.773M7.162 16.547V20","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    